module.exports = __webpack_public_path__ + "static/media/def-big.719ca337.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/def-big.gif
// module id = 187
// module chunks = 0